// This is a skeleton starter React page generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import { ModeContext } from "../components/plasmic/36_dot_22/PlasmicGlobalVariant__Mode";
import { PlasmicList } from "../components/plasmic/36_dot_22/PlasmicList";
// import characters from "../sketches/characters";

function List() {
  // const olStyles = {
  // };

  // const liStyles = {
  // };


  return (
    <ModeContext.Provider value={undefined}>
      <PlasmicList 
        // characterList
      />
    </ModeContext.Provider>
  );
}

export default List;
